import React from 'react';
import PropTypes from 'prop-types';

import gift from '../../assets/gift.svg';
import travel from '../../assets/travel.svg';

const FormSidebar = ({ auction, type }) => {
  const selectIcon = (auctionType) => {
    switch (auctionType) {
      case 'NATIONAL':
      case 'INTERNATIONAL':
        return travel;
      case 'PRODUCT':
      default:
        return gift;
    }
  };

  const iconSVG = selectIcon(type);

  return (
    <>
      <div className="bg-alabaster bd-alabaster p-3 bdr-5 d-none d-sm-block">
        <img src={iconSVG} className="img-fluid mb-3" alt="Gift" />
        <h4 className="text-tangaroa">{auction}</h4>
      </div>
      <div className="bg-alabaster bd-alabaster p-3 bdr-5 d-block d-sm-none d-flex">
        <img src={iconSVG} className="img-fluid mb-3" alt="Gift" />
        <h4 className="text-tangaroa ml-3">{auction}</h4>
      </div>
    </>
  );
};

FormSidebar.defaultProps = {
  type: gift,
};

FormSidebar.propTypes = {
  auction: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default FormSidebar;
